var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileIcon = function SvgProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12856_15268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.34014 20.7031L0.482248 16.2104C0.317596 15.9517 0.392081 15.6929 0.65474 15.5792L6.62926 12.9252C6.9468 12.7919 7.18986 12.8703 7.39371 13.1839L10.6358 18.3313",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5123 22.9689H23.1961L22.1219 15.293C21.5809 11.8863 19.6522 10.3887 17.1001 10.3887C15.2379 10.3887 13.5248 11.4237 12.5486 13.8268L10.169 19.4289L4.25328 20.0483C3.55547 20.26 3.06543 20.7853 3.06543 21.7811C3.06543 22.9689 3.83381 23.6079 5.1471 23.6079H11.9292C12.9171 23.6079 13.6737 23.0552 14.152 22.0751C14.8106 20.7305 15.9357 18.4057 16.6375 16.9513",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11985 17.7903L4.51221 19.9974",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9316 5.01797C17.9316 7.574 15.8617 9.64391 13.3056 9.64391C10.7496 9.64391 8.67969 7.57007 8.67969 5.01797C8.67969 2.46586 10.7496 0.392029 13.3056 0.392029C15.8617 0.392029 17.9316 2.46586 17.9316 5.01797Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12856_15268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5884,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile_icon.17a9834c.svg";
export { ForwardRef as ReactComponent };